var _g, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#BF5B37",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 60,
    height: 60,
    transform: "rotate(45 60 60)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 8,
    ry: 8,
    fill: "#BF5B37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 52h-4c-2 0-2.5 1-2.5 2.5v3.5h6l-1 6h-5v14h-6v-14h-4v-6h4v-4c0-4 2-7 7-7h5v6z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeFacebook);
export default __webpack_public_path__ + "static/media/icone-facebook.6e690d92f435e6869322c14bfe5b3b90.svg";
export { ForwardRef as ReactComponent };